import React, { Component } from 'react';
import './style.css';
import { Question, End } from '../../../comparison-new/components';
import { Sliderbar } from '../../components';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { URL_START } from '../../constants';

class Interview extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props };
    this.createAspect = this.createAspect.bind(this);
    this.saveAspect = this.saveAspect.bind(this);
    this.saveProjectObject = this.saveProjectObject.bind(this);
    this.saveQuestion = this.saveQuestion.bind(this);
    this.findNextPath = this.findNextPath.bind(this);
    this.skipPair = this.skipPair.bind(this);
    this.skipProjectObject = this.skipProjectObject.bind(this);
    this.getAnswered = this.getAnswered.bind(this);
    this.getSkipped = this.getSkipped.bind(this);
    this.pathBase = URL_START + '/' + this.props.project;
  }

  setStateAndSession(param) {
    const state = Object.assign({}, this.state, param);
    sessionStorage.setItem('interview', JSON.stringify(state));
    this.setState(param);
  }

  getAnswered(el) {
    return this.getFiltered(el, 'answered');
  }

  getSkipped(el) {
    return this.getFiltered(el, 'skipped');
  }

  getFiltered(el, property) {
    return el.filter(element => {
      if (element[property]) {
        return true;
      }
      return false;
    });
  }

  getUnanswered(el) {
    return el.filter(element => {
      if (element.skipped || element.answered) {
        return false;
      }
      return true;
    });
  }

  getFirstUnansweredProjectObjectId(projectObjects) {
    let longestLength = -1;
    let longestId = -1;
    projectObjects.map(projectObject => {
      const unanswered = projectObject.aspects.filter(aspect => {
        if (aspect.skipped || aspect.answered) {
          return false;
        }
        return true;
      });

      if (unanswered.length > longestLength) {
        longestLength = unanswered.length;
        longestId = projectObject.id;
      }
      return projectObject;
    });

    return longestId;
  }

  getUnansweredItemIndex(el) {
    return el.findIndex(element => {
      if (element.skipped || element.answered) {
        return false;
      }
      return true;
    });
  }

  getCompletionStatus() {
    const answeredPairs = this.getAnswered(this.props.objectPairs).length;

    const numQuestions = this.props.questions.length;
    const answeredQuestions = this.getAnswered(this.props.questions).length;

    const numPOA = this.props.enabledProjectObjects.length;
    const answeredPOA = this.getNumAnsweredProjectObjectAspects(
      this.props.enabledProjectObjects,
      this.getUnanswered
    );

    const count = answeredPairs + answeredQuestions + answeredPOA;
    const total =
      this.props.numOfElements +
      numPOA * this.props.numOfElements +
      numQuestions;
    return `${count + 1}/${total}`;
  }

  checkCompleted() {
    const answeredPairs = this.getAnswered(this.props.objectPairs).length;

    const numQuestions = this.props.questions.length;
    const answeredQuestions = this.getAnswered(this.props.questions).length;

    const numPOA = this.props.enabledProjectObjects.length;
    const answeredPOA = this.getNumAnsweredProjectObjectAspects(
      this.props.enabledProjectObjects,
      this.getUnanswered
    );

    const count = answeredPairs + answeredQuestions + answeredPOA;
    const total =
      this.props.numOfElements +
      numPOA * this.props.numOfElements +
      numQuestions;

    return count >= total;
  }

  getPOAStatusCount() {
    const numPOA = this.props.enabledProjectObjects.length;
    const answeredPOA = this.getNumAnsweredProjectObjectAspects(
      this.props.enabledProjectObjects,
      this.getUnanswered
    );

    const count = answeredPOA % numPOA;

    return `${count + 1}/${numPOA}`;
  }

  getNumAnsweredProjectObjectAspects(objects, fn) {
    let unAnsweredCount = 0;
    let count = 0;
    objects.map(function(singleObject) {
      unAnsweredCount += fn(singleObject.aspects).length;
      count += singleObject.aspects.length;
      return unAnsweredCount;
    });
    return count - unAnsweredCount;
  }

  createAspect(singleAspect, pairId) {
    let aspects = this.state.aspects;
    let objectPairs = this.state.objectPairs;
    let projectObjects = this.state.enabledProjectObjects;

    objectPairs[pairId].answer = {
      term: singleAspect.answer.term,
      opposite: singleAspect.answer.opposite,
      description: singleAspect.answer.story
    };
    if (
      singleAspect.answer.term &&
      singleAspect.answer.opposite &&
      singleAspect.answer.story
    ) {
      objectPairs[pairId].answered = true;
    }

    const date = new Date();
    let aspect = {
      term: singleAspect.answer.term,
      opposite: singleAspect.answer.opposite,
      description: singleAspect.answer.story,
      added: date.toISOString()
    };
    aspects.push(aspect);

    projectObjects.map(value => {
      value.aspects.push({ ...aspect });
      return value;
    });

    let output = this.state.output;
    output.aspects = aspects;

    this.setStateAndSession({
      aspects: aspects,
      objectPairs: objectPairs,
      projectObjects: projectObjects,
      output: output
    });
  }

  saveAspect(singleAspect, aspectId) {
    let aspects = this.state.aspects;
    let projectObjects = this.state.enabledProjectObjects;

    const date = new Date();
    let aspect = {
      ...aspects[aspectId],
      ...{
        term: singleAspect.answer.term,
        opposite: singleAspect.answer.opposite,
        added: date.toISOString()
      }
    };

    if (aspect.term && aspect.opposite) {
      projectObjects.map(value => {
        let newAspect = {
          term: singleAspect.answer.term,
          opposite: singleAspect.answer.opposite,
          added: date.toISOString()
        };
        newAspect = { ...value.aspects[aspectId], ...newAspect };
        value.aspects[aspectId] = newAspect;
        return value;
      });
      aspects[aspectId] = aspect;
    }

    let output = this.state.output;
    output.aspects = aspects;

    this.setStateAndSession({
      aspects: aspects,
      projectObjects: projectObjects,
      output: output
    });
  }

  saveProjectObject(answer, projectObjectUuid, aspectId) {
    let aspects = this.state.aspects;
    let projectObjects = this.state.enabledProjectObjects;
    let index = projectObjects.findIndex(
      item => item.uuid === projectObjectUuid
    );
    const date = new Date();
    projectObjects[index].aspects[aspectId].answer = answer;
    projectObjects[index].aspects[aspectId].answered = true;
    projectObjects[index].aspects[aspectId].added = date.toISOString();

    if (!this.getUnanswered(projectObjects[index].aspects).length) {
      projectObjects[index].answered = true;
    }

    aspects[aspectId] = projectObjects[index].aspects[aspectId];

    let outputProjectObjects = [];
    projectObjects.forEach(projectObject => {
      if (projectObject.answered) {
        projectObject.aspects.forEach((aspect, index) => {
          if (aspect.answered) {
            outputProjectObjects.push({
              uuid: projectObject.uuid,
              aspects: index,
              percentage: aspect.answer,
              added: aspect.added
            });
          }
        });
      }
    });
    let output = this.state.output;
    output.projectObjects = outputProjectObjects;

    this.setStateAndSession({
      aspects: aspects,
      projectObjects: projectObjects,
      output: output
    });
  }

  saveQuestion(value, questionUuid) {
    let questions = this.state.questions;
    let index = questions.findIndex(item => item.uuid === questionUuid);
    const date = new Date();
    questions[index].answer = value;
    questions[index].answered = true;
    questions[index].added = date.toISOString();

    let outputQuestions = [];
    questions.forEach(value => {
      if (value.answer instanceof Array) {
        value.answer.forEach(answer => {
          outputQuestions.push({
            question: value.uuid,
            answer: answer,
            added: value.added
          });
        });
      } else {
        outputQuestions.push({
          question: value.uuid,
          answer: value.answer,
          added: value.added
        });
      }
    });

    let output = this.state.output;
    output.questions = outputQuestions;

    this.setStateAndSession({
      questions: questions,
      output: output
    });
  }

  restartInterview() {
    let objectPairs = this.state.objectPairs;
    objectPairs.forEach(projectObject => {
      if (projectObject.skipped) {
        projectObject.skipped = false;
      }
    });
    this.setStateAndSession({ objectPairs: objectPairs });
    return this.findNextPath();
  }

  findNextPath() {
    const pathBase = URL_START + '/' + this.props.project + '/';

    const projectObjectId = this.getFirstUnansweredProjectObjectId(
      this.state.enabledProjectObjects
    );

    if (typeof projectObjectId !== 'undefined') {
      const projectObject = this.state.enabledProjectObjects.find(
        projectObject => {
          if (projectObject.id === projectObjectId) {
            return true;
          }
          return false;
        }
      );
      const aspectId = this.getUnansweredItemIndex(projectObject.aspects);
      if (aspectId !== -1) {
        const objectPairs = this.getUnanswered(this.state.objectPairs);
        const pairIndex = this.state.objectPairs.indexOf(objectPairs[0]);
        return (
          pathBase +
          'pair/' +
          pairIndex +
          '/object/' +
          projectObject.uuid +
          '/' +
          aspectId
        );
      }
    }

    const objectPairs = this.getUnanswered(this.state.objectPairs);
    const answeredOP = this.getAnswered(this.state.objectPairs);
    const skippedOP = this.getSkipped(this.state.objectPairs);

    if (
      this.state.objectPairs.length - skippedOP.length - answeredOP.length <
      this.props.numOfElements - answeredOP.length
    ) {
      return this.restartInterview();
    }

    if (objectPairs.length && answeredOP.length < this.props.numOfElements) {
      return pathBase + 'pair/' + objectPairs[0].pairId;
    }

    const questions = this.getUnanswered(this.state.questions);
    if (questions.length) {
      return pathBase + 'question/' + questions[0].uuid;
    }

    if (this.checkCompleted()) {
      return pathBase + 'end';
    }

    return pathBase + '404';
  }

  skipPair(props) {
    let objectPairs = this.state.objectPairs;
    objectPairs[props.pairId].skipped = true;
    objectPairs[props.pairId].answered = false;
    objectPairs[props.pairId].answer = { term: null, opposite: null };

    this.setStateAndSession({
      objectPairs: objectPairs
    });
    const nextPath = this.findNextPath();
    return nextPath;
  }

  skipProjectObject(aspect_id, object_uuid) {
    this.saveProjectObject(-999, object_uuid, aspect_id);

    return this.findNextPath();
  }

  render() {
    return (
      <div>
        <Switch>
          <Route
            path={URL_START + '/:project'}
            exact
            render={() => <Redirect to={this.findNextPath()} />}
          />

          <Route
            path={URL_START + '/:project/pair/:pairid/object/:uuid/:aspect_id'}
            render={({ match }) => {
              let projectObject = this.state.enabledProjectObjects.filter(
                e => e.uuid === match.params.uuid
              )[0];

              if (!projectObject) {
                projectObject = this.getUnanswered(
                  this.state.enabledProjectObjects
                )[0];
                if (!projectObject) {
                  return <Redirect to={this.findNextPath()} />;
                }
              }

              if (!projectObject.aspects[match.params.aspect_id]) {
                return <Redirect to={this.findNextPath()} />;
              }

              let disabledBackButton =
                this.props.location.pathname.indexOf(
                  this.state.enabledProjectObjects[0].uuid
                ) !== -1;

              return (
                <div>
                  <Sliderbar
                    statusCount={this.getPOAStatusCount()}
                    left={projectObject.aspects[match.params.aspect_id].term}
                    right={
                      projectObject.aspects[match.params.aspect_id].opposite
                    }
                    name={projectObject.name}
                    value={projectObject.aspects[match.params.aspect_id].answer}
                    image={projectObject.image}
                    projectObjectUuid={projectObject.uuid}
                    aspectId={match.params.aspect_id}
                    save={this.saveProjectObject}
                    saveAspect={this.saveAspect}
                    skip={this.skipProjectObject}
                    disabledBack={disabledBackButton}
                    findNextPath={this.findNextPath}
                  />
                </div>
              );
            }}
          />

          <Route
            path={URL_START + '/:project/question/:uuid'}
            render={({ match }) => {
              const URL_PROJECT =
                URL_START + '/' + match.params.project + '/question/';
              let question = this.state.questions.filter(
                e => e.uuid === match.params.uuid
              )[0];

              if (!question) {
                question = this.getUnanswered(this.state.questions)[0];
                if (!question) {
                  return <Redirect to={this.findNextPath()} />;
                }
                return <Redirect to={URL_PROJECT + question.uuid} />;
              }

              return (
                <div>
                  <Question
                    question={question}
                    completionStatus={this.getCompletionStatus()}
                    next={this.findNextPath()}
                    save={this.saveQuestion}
                  />
                </div>
              );
            }}
          />

          <Route
            path={URL_START + '/:project/question'}
            render={({ match }) => {
              const question = this.getUnanswered(this.state.questions)[0];
              if (!question) {
                return <Redirect to={this.findNextPath()} />;
              }
              return (
                <Redirect
                  to={
                    URL_START +
                    '/' +
                    match.params.project +
                    '/question/' +
                    question.uuid
                  }
                />
              );
            }}
          />

          <Route
            path={URL_START + '/:project/end'}
            exact
            render={() => <End state={this.state} />}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Interview);



// WEBPACK FOOTER //
// ./src/comparison-predefined/components/Interview/index.js